import React, { useState } from "react";
import FaiBox from "../../../MuiComponents/FaiBox";
import FaiTypography from "../../../MuiComponents/FaiTypography";
import theme from "../../../assets/theme";
import { Tab, Tabs } from "@mui/material";
import ProductForm from "./component/ProductForm";
import MultiProduct from "./component/MultiProduct";

function AddProductForm() {
	const { typography, palette } = theme;
	const [tabValue, setTabValue] = useState<number>(0);

	const handleSetTabValue = (event, newValue) => {
		setTabValue(newValue);
	};

	return (
		<>
			<FaiBox className={"add-product"}>
				<FaiTypography
					variant={"h4"}
					fontWeight={typography.fontWeightMedium}
					mb={"21px"}
				>
					Add Product
				</FaiTypography>
				<FaiBox className={"tab-navigation"}>
					<FaiBox sx={{ width: "100%" }} mb={2}>
						<FaiBox sx={{ borderBottom: 1, borderColor: "divider" }}>
							<Tabs value={tabValue} onChange={handleSetTabValue}>
								<Tab label="Add a Product" />
								<Tab label="Add Multiple Product" />
							</Tabs>
						</FaiBox>
					</FaiBox>

					<FaiBox className={"tab-body"}>
						{tabValue == 0 && <ProductForm />}{" "}
						{tabValue == 1 && <MultiProduct />}
					</FaiBox>
				</FaiBox>
			</FaiBox>
		</>
	);
}

export default AddProductForm;
